import React from "react";

const Approvals = () => {
  return <div>Approvals</div>;
};

export default Approvals;
